var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{staticClass:"clickable",on:{"click":_vm.change_sort}},[(_vm.active)?_c('span',{staticClass:"pr-2"},[(_vm.ascending)?_c('i',{staticClass:"fa fa-caret-down"}):_c('i',{staticClass:"fa fa-caret-up"})]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }